import events from 'eventslibjs'

export default function (dom, opts) {
  var options = {
    clsSelector: '.cookie-banner',
    okTrigger: '[data-cookie-ok]',
    closeTrigger: '[data-cookie-close]',
    openCls: 'cookie-banner--show',
    ...opts
  }

  init()

  function init() {
    /* check cookie */
    let cookieaccept = getCookie('cookie-accept');
    getContainer().classList.add(options.openCls)

    if(cookieaccept) {
        getContainer().classList.remove(options.openCls)
    }
    events.on('click', options.closeTrigger, onClose);
    events.on('click', options.okTrigger, onClose);
  }

  function onClose() {
    getContainer().classList.remove(options.openCls)

    /* set cookie */
    setCookie('cookie-accept', 1, 365);
  }

  function getContainer() {
    return options.clsSelector ? document.querySelector(options.clsSelector) : dom
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

}
